import type { FunctionComponent } from "react"

import { CardLayout } from "@/modules/companies/client/components/RecruitmentPatternInformation/CardLayout/CardLayout"
import { Column } from "@/modules/companies/client/components/RecruitmentPatternInformation/MonthCard/Column/Column"
import { Raw } from "@/modules/companies/client/components/RecruitmentPatternInformation/MonthCard/Raw/Raw"
import { useCompanyAnalyticsData } from "@/modules/companies/client/components/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./MonthCard.module.css"

export const MonthCard: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const { dataCompany } = useCompanyFetch()

  const { hasEnoughData, topMonths } = useCompanyAnalyticsData()

  if (!dataCompany) return null
  if (!hasEnoughData || !topMonths) return null

  const { months, scale } = topMonths
  const stepScale = Math.floor(scale / 6)

  return (
    <CardLayout
      title={t("companies_client.recruitmentPatternInformation.month.title", {
        name: dataCompany.page.name,
      })}
      data-testid="recruitementPattern_card"
    >
      <div className={styles.graph}>
        <div className={styles.grid} aria-hidden="true">
          <Raw value={scale} />
          <Raw value={stepScale * 5} />
          <Raw value={stepScale * 4} />
          <Raw value={stepScale * 3} />
          <Raw value={stepScale * 2} />
          <Raw value={stepScale} />
          <Raw value={0} />
        </div>
        <ul className={styles.data}>
          {months.map(month => {
            return <Column key={month.month} data={month.contractCount} maxValue={scale} date={new Date(month.month)} />
          })}
        </ul>
      </div>
      <ul aria-hidden="true" className={styles.legend}>
        {Object.entries(months[0].contractCount).map(position => {
          const [contractName] = position
          return (
            <li key={contractName} className={styles.item}>
              {contractName}
            </li>
          )
        })}
      </ul>
    </CardLayout>
  )
}
